import { ConsumerIdentityType } from '@mc-alberta/types';
import { ConsumerIdentityTypeEmvcoVersionPointNine } from './models/consumer-identity.enum';
import { DEFAULT_IDENTITY_PROVIDER } from './models/consumer-identity.const';
export class ConsumerIdentityUtils {
    /**
     * Ensures consumer identity is in EMVCo v0.9 by transforming from v1.0 if needed.
     */
    static transformToVersionPointNine(consumerIdentity) {
        // Already the expected version
        if (consumerIdentity && this.isVersionPointNine(consumerIdentity)) {
            return consumerIdentity;
        }
        let identityType;
        switch (consumerIdentity === null || consumerIdentity === void 0 ? void 0 : consumerIdentity.identityType) {
            case ConsumerIdentityType.EMAIL_ADDRESS:
                identityType = ConsumerIdentityTypeEmvcoVersionPointNine.EMAIL;
                break;
            case ConsumerIdentityType.MOBILE_PHONE_NUMBER:
                identityType = ConsumerIdentityTypeEmvcoVersionPointNine.SMS;
                break;
            default:
                return;
        }
        return {
            identityType,
            identityValue: consumerIdentity.identityValue,
            identityProvider: consumerIdentity.identityProvider || DEFAULT_IDENTITY_PROVIDER
        };
    }
    /**
     * Check if consumer identity is in EMVCo v0.9 format.
     */
    static isVersionPointNine(consumerIdentity) {
        if (!consumerIdentity)
            return false;
        return (consumerIdentity.identityType === ConsumerIdentityTypeEmvcoVersionPointNine.EMAIL ||
            consumerIdentity.identityType === ConsumerIdentityTypeEmvcoVersionPointNine.SMS);
    }
    /**
     * Check if consumer identity is in EMVCo v1.0 format.
     */
    static isVersionOne(consumerIdentity) {
        if (!consumerIdentity)
            return false;
        return (consumerIdentity.identityType === ConsumerIdentityType.EMAIL_ADDRESS ||
            consumerIdentity.identityType === ConsumerIdentityType.MOBILE_PHONE_NUMBER);
    }
}
